/**
 * Type-safe helper function that mutates the provided RequestInit object to set value v
 * for a header named k, regardless of how the object's 'headers' property is formatted.
 */
export function setHeaderValue(init: RequestInit, k: string, v: string) {
  if (!init.headers) {
    init.headers = { [k]: v };
  } else if (init.headers instanceof Headers) {
    init.headers.set(k, v);
  } else if (Array.isArray(init.headers)) {
    init.headers.push([k, v]);
  } else {
    init.headers[k] = v;
  }
}

/**
 * Given a string, returns its base64-encoded representation. Uses Buffer in Node;
 * window.btoa in the browser.
 */
export function encodeToBase64(plaintext: string): string {
  if (typeof window !== "undefined") {
    return window.btoa(plaintext);
  }
  return Buffer.from(plaintext).toString("base64");
}

/**
 * Given a base64-encoded string, returns its plain-text representation. Uses Buffer in
 * Node; window.atob in the browser.
 */
export function decodeFromBase64(encoded: string): string {
  if (typeof window !== "undefined") {
    return window.atob(encoded);
  }
  return Buffer.from(encoded, "base64").toString();
}

/**
 * Need this function to map language names as stored in svc-content to the expected names
 * in sj_frontend—which match the names of the engines in the content repo)
 */
export function replLanguageMap(lang: string): string {
  switch (lang) {
    case "csharp":
      return "dotnet";
    case "javascript":
      return "node";
    default:
      return lang;
  }
}
